var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CompanyApi } from '@ClientApi/company';
export const STORE_COMPANY = 'STORE_COMPANY';
export const STORE_COMPANY_POLICY = 'STORE_COMPANY_POLICY';
export const STORE_COMPANY_ACCOUNTING_INTEGRATION = 'STORE_COMPANY_ACCOUNTING_INTEGRATION';
export const SET_LOADING_ACCOUNTING_INTEGRATION = 'SET_LOADING_ACCOUNTING_INTEGRATION';
export class StoreCompany {
    constructor(company) {
        this.company = company;
        this.type = STORE_COMPANY;
    }
}
export class SetLoadingAccountingIntegration {
    constructor(loading) {
        this.loading = loading;
        this.type = SET_LOADING_ACCOUNTING_INTEGRATION;
    }
}
export const getCompanyWithAccountingIntegration = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetLoadingAccountingIntegration(true));
    try {
        const company = yield CompanyApi.get(['accounting_integration']);
        dispatch(new StoreCompany(company));
    }
    finally {
        dispatch(new SetLoadingAccountingIntegration(false));
    }
});
export const getCompanyWithCustomOnBoardingChecklist = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const company = yield CompanyApi.get(['custom_onboarding_checklist']);
    dispatch(new StoreCompany(company));
});
export class StoreCompanyPolicy {
    constructor(companyPolicy) {
        this.companyPolicy = companyPolicy;
        this.type = STORE_COMPANY_POLICY;
    }
}
export class StoreCompanyAccountingIntegration {
    constructor(accountingIntegration) {
        this.accountingIntegration = accountingIntegration;
        this.type = STORE_COMPANY_ACCOUNTING_INTEGRATION;
    }
}
